import {
    createBrowserRouter,
    RouterProvider
} from "react-router-dom";
import {Notifications} from "@mantine/notifications";

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import '@flexinet/ui-components/style.css'


import {MantineProvider} from "@mantine/core";
import {AnalyticsAuthListener} from "@flexinet/analytics-components";
import {SessionGuardProvider} from "@flexinet/auth-components";
import {theme} from "./theme.ts";
import {AuthProvider} from "./providers/AuthProvider.tsx";
import {actions} from "./config/rbac/actions.ts";
import {VerifiedPermissionsProvider} from "./providers/VerifiedPermissionsProvider.tsx";
import {routesConfig} from "./config/routes.tsx";
import {UserAttributesProvider} from "./providers/UserAttributesProvider.tsx";


const router = createBrowserRouter(routesConfig)

function App() {

    return (
        <MantineProvider theme={theme}>
            <SessionGuardProvider>
                <AuthProvider>
                    <AnalyticsAuthListener/>
                    <UserAttributesProvider>
                        <VerifiedPermissionsProvider actions={actions}>
                            <Notifications position={'bottom-left'}/>
                            <RouterProvider router={router}/>
                        </VerifiedPermissionsProvider>
                    </UserAttributesProvider>
                </AuthProvider>
            </SessionGuardProvider>
        </MantineProvider>
    )
}

export default App
